export function requestSimulador(params, body) {
	return {
		type: '@clientSimulador/REQUEST_SIMULADOR',
		payload: { params, body },
	};
}

export function successSimulador(dados) {
	return {
		type: '@clientSimulador/SUCCESS_SIMULADOR',
		payload: { dados },
	};
}

export function failureSimulador(error) {
	return {
		type: '@clientSimulador/FAILURE_SIMULADOR',
		payload: { error },
	};
}

export function requestLink(dados) {
	return {
		type: '@clientSimulador/REQUEST_LINK',
		payload: { dados },
	};
}
